import PropTypes from "prop-types"
import { Navigate, Outlet, useLocation } from "react-router-dom"

import { RoutesPaths } from "../../constants/user-routes"

export const PrivateRoute = ({
  redirectPath,
  auth,
  children,
  requiredRoles,
  businessAccounts,
  ...props
}) => {
  let { pathname, search } = useLocation()

  // check authorization
  if (!auth) {
    return (
      <Navigate
        to={redirectPath + (search || "")}
        state={{ reference: pathname + (search || "") }}
        replace
      />
    )
  }

  // check roles if they in props
  if (requiredRoles && requiredRoles.length > 0) {
    const hasRequiredRole =
      businessAccounts?.some(({ role }) => requiredRoles.includes(role?.id)) ||
      businessAccounts?.length === 0

    if (!hasRequiredRole) {
      return <Navigate to={RoutesPaths.dashboard.root} replace />
    }
  }

  return children || <Outlet />
}

PrivateRoute.propTypes = {
  redirectPath: PropTypes.string.isRequired,
  auth: PropTypes.bool,
  requiredRoles: PropTypes.array,
  businessAccounts: PropTypes.array
}

export default PrivateRoute
